import { useGetGuests } from 'api-hooks/guest';
import { OnChangeParams, Value } from 'baseui/select';
import { guestOptionTransformer } from 'legacy-modules/master/guest/components/select-input';
import React from 'react';

export default function useGuestSelectAction(id?: string) {
  const query = useGetGuests({
    params: {
      limit: -1,
    },
  });
  const { data } = query;
  const guests = (data?.data || []).map((guest) =>
    guestOptionTransformer(guest),
  );

  const [guestId, setGuestId] = React.useState<string | null>(id ?? null);

  const value: Value = React.useMemo(() => {
    if (guestId) {
      const guest = guests.find((guest) => guest.id === guestId);
      return guest ? [guest] : [];
    }
    return [];
  }, [guestId, guests]);

  const onChange = React.useCallback((params: OnChangeParams) => {
    if (params.option?.id) {
      const guestId = params.option.id as string;
      setGuestId(guestId);
    } else {
      setGuestId(null);
    }
  }, []);

  return {
    ...query,
    value,
    guestId,
    onChange,
    guests,
  };
}
